export default __webpack_public_path__ + "static/media/028-signal.4fd18521.png";